

export enum PulseColor {
  GREEN = 'green',
  CYAN = 'cyan',
  TEAL = 'teal',
}